export const TicketStatus = {
    open: "open",
    closed: "closed",
    attentionNeeded: "attentionNeeded"
}